import enterpriseWorkflowService from "@/services/enterprises/enterpriseWorkflowService";
import operationLocalDbService from "@/services/operations/operationLocalDbService";

const INITIAL_STATE = {
  enterpriseWorkflows: [
    // {
    //   id: "string",
    //   workflow_statuses: [
    //     {
    //       category: {
    //         color: "string",
    //         id: "string",
    //       },
    //       id: "string",
    //       is_complete: true,
    //       is_initial: true,
    //       label: "string",
    //       next_action_label: "string",
    //       short_label: "string",
    //       sort_order: 0,
    //       supplement_label: "string",
    //     },
    //   ],
    //   workflow_transactions: [
    //     {
    //       id: "string",
    //       is_progress: true,
    //       label: "string",
    //       require_trigger_num: 0,
    //       source_workflow_global: true,
    //       source_workflow_status_id: "string",
    //       target_workflow_status_id: "string",
    //       trigger: "BUTTON",
    //     },
    //   ],
    // },
  ], // : EnterpriseWorkflowTransaction[]
};

export default {
  isRegistered: false,
  namespaced: true,
  state: {
    ...INITIAL_STATE,
  },
  mutations: {
    /**
     * enterprise workflow 設定をセットするミューテーション
     *
     * @param {Object} state - Vuex ストアの状態オブジェクト
     * @param {EnterpriseWorkflow[]} data - データ
     * @returns {void}
     */
    SET_WORKFLOWS(state, data) {
      state.enterpriseWorkflows = data;
    },

    RESET_STATE(state) {
      Object.assign(state, INITIAL_STATE);
    },
  },
  actions: {
    /**
     * enterprise workflow 設定 を storeにセットする
     *
     * @param {Object} context - The Vuex store context object
     * @param {Function} context.commit - The commit function
     * @returns {Promise<void>}
     * @throws {Error}
     */
    async setEnterpriseWorkflows({ commit }) {
      const enterpriseWorkflows = await enterpriseWorkflowService.getEnterpriseWorkflows();
      commit("SET_WORKFLOWS", enterpriseWorkflows.data || []);
      operationLocalDbService.setEnterpriseWorkflowsToLocalDB(
        enterpriseWorkflows.data || []
      );
    },

    /**
     * enterprise workflows  を localDB から取得し storeにセットする
     *
     * @returns {Promise<void>}
     * @throws {Error}
     */
    async setEnterpriseWorkflowsFromLocalDB({ commit }) {
      const enterpriseWorkflows = await operationLocalDbService.getEnterpriseWorkflowsFromLocalDB();
      commit("SET_WORKFLOWS", enterpriseWorkflows || []);
    },

    /**
     * enterprise workflows  を localDB から取得し storeにセットする
     * localDBにない場合はAPIから取得し store にセットする
     *
     * @returns {Promise<void>}
     * @throws {Error}
     */
    async setEnterpriseWorkflowsFromLocalDBAndAPI({ dispatch, getters }) {
      await dispatch("setEnterpriseWorkflowsFromLocalDB");
      if (!getters.hasEnterpriseWorkflows) {
        dispatch("setEnterpriseWorkflows");
      }
    },

    /**
     * storeを初期値に戻す
     *
     * @param {Object} context - The Vuex store context object
     * @param {Function} context.commit - The commit function
     * @returns {Promise<void>}
     */
    async resetState({ commit }) {
      commit("RESET_STATE");
    },
  },
  getters: {
    validEnterpriseWorkflows({ enterpriseWorkflows }) {
      return enterpriseWorkflowService.validEnterpriseWorkflows(
        enterpriseWorkflows
      );
    },

    hasEnterpriseWorkflows(_, { validEnterpriseWorkflows }) {
      return validEnterpriseWorkflows.length > 0;
    },

    workflowStatuses(_, { validEnterpriseWorkflows }) {
      return validEnterpriseWorkflows
        .map(ew => ew.workflow_statuses)
        .flat()
        .filter(ws => enterpriseWorkflowService.isEnterpriseWorkflowStatus(ws));
    },

    // status.id によるマップ
    workflowStatusMap(_, { workflowStatuses }) {
      return enterpriseWorkflowService.enterpriseWorkflowStatusMap(
        workflowStatuses
      );
    },

    // WorkflowStatusIdによるworkflowのマップ
    workflowMapByWorkflowStatusId(_, { validEnterpriseWorkflows }) {
      return enterpriseWorkflowService.enterpriseWorkflowMapByWorkflowStatusId(
        validEnterpriseWorkflows
      );
    },
  },
};
